export interface DictationLanguage {
  code: string;
  label: string;
  shortLabel: string;
}

export const DICTATION_LANGUAGES: DictationLanguage[] = [
  { code: 'en-ZA', label: 'English (South Africa)', shortLabel: 'EN-ZA' },
  { code: 'en-GB', label: 'English (UK)', shortLabel: 'EN-GB' },
  { code: 'en-US', label: 'English (US)', shortLabel: 'EN-US' },
  { code: 'en-AU', label: 'English (Australia)', shortLabel: 'EN-AU' },
  { code: 'af-ZA', label: 'Afrikaans', shortLabel: 'AF' },
  { code: 'zu-ZA', label: 'isiZulu', shortLabel: 'ZU' },
  { code: 'xh-ZA', label: 'isiXhosa', shortLabel: 'XH' },
];

export const DEFAULT_DICTATION_LANGUAGE = DICTATION_LANGUAGES[0];

export const DICTATION_LANG_STORAGE_KEY = 'dictationLang';

export function findDictationLanguage(code: string | null | undefined): DictationLanguage {
  if (!code) return DEFAULT_DICTATION_LANGUAGE;
  return (
    DICTATION_LANGUAGES.find((lang) => lang.code === code) ?? DEFAULT_DICTATION_LANGUAGE
  );
}
